import React, { useEffect, useState } from 'react';
import { withStyles, styled } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Slide from '@material-ui/core/Slide';
import PropTypes from 'prop-types';
import { Box, Checkbox, FormControlLabel, Icon, Tooltip } from '@material-ui/core';
import ContactSupportIcon from '@material-ui/icons/ContactSupport';
import { useDispatch, useSelector } from 'react-redux';
import { saveDialogScrollLocation, triggerTour } from '../../../store/global/actions';
import MinimizeSharpIcon from '@material-ui/icons/MinimizeSharp';
import useDebounce from '../../../hooks/useDebounce';
import { getDialogScrolls } from '../../../store/global/selectors';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});


const StyledDialogContent = styled(MuiDialogContent)({
  overflowY: 'hidden',
});

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
    marginLeft: 10,
  },
  extraButton: {
    position: 'absolute',
    right: theme.spacing(10),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
    marginLeft: 10,
  },
});

export const DialogTitle = withStyles(styles)((props) => {
  const { children, extraHeaderButton, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {extraHeaderButton ? <Grid className={classes.extraButton}>{extraHeaderButton}</Grid> : null}
      {onClose ? (
        <>
        {
          props?.isMinimize ? 
          <Tooltip title='Minimize'>
            <IconButton aria-label="close" className={classes.closeButton} onClick={onClose} style={{textTransform: 'capitalize'}}>
              <MinimizeSharpIcon />
            </IconButton>
          </Tooltip>
          :
          <Tooltip title='Close'>
          <IconButton aria-label="close" className={classes.closeButton} onClick={onClose} style={{textTransform: 'capitalize'}}>
            <CloseIcon />
          </IconButton>
          </Tooltip>
        }
        </>
        
      ) : null}
    </MuiDialogTitle>
  );
});

export const DialogContent = withStyles((theme) => ({
  root: ({ disableContentPadding, minWidth, minHeight, overflowY = 'inherit' }) => {
    let rest = {};
    if (minHeight) rest = { minHeight: minHeight };
    return {
      padding: disableContentPadding ? 0 : theme.spacing(2),
      minWidth: minWidth || 300,
      overflowY: overflowY !== undefined ? overflowY : 'scroll',
      ...rest,
    };
  },
}))(MuiDialogContent);

export const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

function CustomizedDialogs(props) {
  const { handleClose, open, actions, title, minHeight, minWidth, overflowY, container_id, step, isTitleCapital=true, openAppView, setOpenAppView, showAppViewOption } = props;
  const { disableContentPadding, extraHeaderButton, maxWidth, fullScreen, paperProps = {} } = props;

  const [scrollLocation, setScrollLocation] = useState(null)
  const debouncedScrollLocation = useDebounce(scrollLocation)
  const savedScrollLocation = useSelector(getDialogScrolls);

  const [showTour, setTour] = useState(false)
  const dispatch = useDispatch()

  const handleManualTour = () => {
    if(title === 'Backup/Restore'){
      dispatch(triggerTour({currentTour: 'backupModal', initStart: true}))
    }else if(title === "Configuration"){
      dispatch(triggerTour({currentTour: 'configurations', initStart: true}))
    }else if(step === 0){
      dispatch(triggerTour({currentTour: 'blueprintImporter', initStart: true}))
    }else if(step === 2){
      dispatch(triggerTour({currentTour: 'newBlueprintForm', initStart: true}))
    } else if(container_id === "utility-function-dialog"){
      dispatch(triggerTour({currentTour: 'utilityFunctionModal', initStart: true}))
    }
  }

  const handleScrollRemember = (event) => {
    if(props?.rememberScroll){
      setScrollLocation(event?.target?.scrollTop)
    }
  }

  const onDialogContentLoad = () => {
    if(props?.rememberScroll){
      const dialogContent = document.getElementById(`dialog-content-${container_id}`)
      const item = savedScrollLocation?.find(item => item.title === container_id)

      if(item){
        dialogContent.scrollTop = item.scroll || 0;
      }
    } 
  }

  useEffect(() => {
    if([0,2].includes(step) || title === "Backup/Restore" || title === "Configuration" || container_id === "utility-function-dialog"){
      setTour(true)
    }else{
      setTour(false)
    }
  },[step])
  

  useEffect(() => {
    if(props?.rememberScroll){
      dispatch(saveDialogScrollLocation({title: container_id, scroll: debouncedScrollLocation}))
    }
  },[debouncedScrollLocation])

  return (

    <Dialog id={container_id != undefined ? container_id : "dialog_container"} onEntered={onDialogContentLoad} PaperProps={paperProps || {}} style={{ zIndex: 1500 }} fullWidth={true} maxWidth={maxWidth} fullScreen={fullScreen} TransitionComponent={Transition} onClose={(event, reason) => {
      if(reason && reason === "backdropClick") return false
      handleClose(event)
    }} aria-labelledby="customized-dialog-title" open={open}>
      {title && (
        <DialogTitle id="customized-dialog-title" isMinimize={props?.isMinimize} onClose={handleClose} extraHeaderButton={extraHeaderButton}  >
          <Box style={{display: 'flex', justifyContent: 'space-between', paddingRight: '2rem'}}>
            <span style={isTitleCapital ? {textTransform: 'capitalize'} : {}} id="dialog_title">
              {title}
            </span>
            {
              showTour &&
              <Tooltip title='Show Tour'>
                <Icon onClick={handleManualTour} style={{height: '2rem', width: 'auto', display: 'flex',justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }}>
                  <ContactSupportIcon style={{fontSize: '2rem', color: 'black'}}/>
                </Icon>
              </Tooltip>
            }
          </Box>
        </DialogTitle>
      )}
      <DialogContent id={`dialog-content-${container_id}`} on={onDialogContentLoad} onScroll={handleScrollRemember} {...{ minHeight, minWidth, disableContentPadding, overflowY }} dividers>
        {props.children}
      </DialogContent>
      {actions && <DialogActions>
          {actions}
        </DialogActions>}
    </Dialog>
    
  );
}

CustomizedDialogs.defaultProps = {
  open: false,
  handleClose: () => { },
  children: <React.Fragment />,
  actions: null,
  title: '',
  maxWidth: 'md',
  fullScreen: false,
};

CustomizedDialogs.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  children: PropTypes.node,
  actions: PropTypes.node,
  title: PropTypes.string,
};

export default CustomizedDialogs;
